import isPast from 'date-fns/isPast';

import conf from '../../conf';
import { loadingDataStart } from '../../store/data';
import analytics from '../analytics';
import { openExternalLink } from '../helpers';

import type { Dispatch } from '@avalara/types/actions';
import type { State } from '@avalara/types/reducer-states';

/** Redirects to one of the following (in order of precedence):
 *  1. Return URL passed via query param, if valid
 *  1. Magic link to sign in, if not expired
 *  1. Onboarding
 */
export const redirectAfterPurchase = () => (dispatch: Dispatch, getState: () => State) => {
  dispatch(loadingDataStart());

  const {
    account: { returnUrl },
    avataxSignup: { magicLink, magicLinkExpirationTime },
  } = getState();

  if (returnUrl) {
    let isReturnUrlValid = false;

    try {
      const { hostname } = new URL(returnUrl);
      isReturnUrlValid = hostname.endsWith('.avalara.com') || hostname.endsWith('.avalara.io');
    } catch {
      // error logged below
    }

    if (!isReturnUrlValid) {
      analytics.track('RETURN_URL_ERROR', {
        error: true,
        errorMessage: `"${returnUrl}" is not a valid return URL`,
      });
    } else {
      openExternalLink(returnUrl);
      return;
    }
  }

  if (magicLink) {
    // NOTE(Sasha): Magic link expiration time return in seconds, must be
    // converted to milliseconds because JS uses epoch time (01/01/1970)
    const isExpired = !!magicLinkExpirationTime && isPast(new Date(magicLinkExpirationTime * 1000));
    if (!isExpired) {
      openExternalLink(magicLink);
      return;
    }
  }

  openExternalLink(`${conf.ONBOARDING_URL}?customer=ESB`);
};
